import { render } from "./UiTemplatesDiagramsList.vue?vue&type=template&id=08afd4cd"
import script from "./UiTemplatesDiagramsList.vue?vue&type=script&lang=js"
export * from "./UiTemplatesDiagramsList.vue?vue&type=script&lang=js"

import "./UiTemplatesDiagramsList.vue?vue&type=style&index=0&id=08afd4cd&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__